module.exports = __webpack_public_path__ + "img/pro_six_4.6d9351bd.jpg";